import axios from "axios";
import React, { useState, useEffect } from "react";

export default function DestructionMaintenace({ onBack, onSelect, selected_plant_id }) {

  const [selectedWeight, setSelectedWeight] = useState("");
  const [selectedPlantMaterial, setSelectedPlantMaterial] = useState("Leaf");
  const [selectedReason, setSelectedReason] = useState("Infected");
  const [plantCount, setPlantCount] = useState(0);
  
  // Check if we have multiple plants (from a plot)
  useEffect(() => {
    if (Array.isArray(selected_plant_id)) {
      setPlantCount(selected_plant_id.length);
      console.log(`Found ${selected_plant_id.length} plants for destruction maintenance`);
    }
  }, [selected_plant_id]);

  const org_id = localStorage.getItem("organization");

  const handleUpload = async () => {
    console.log('Selected plant ID:', selected_plant_id);
    try {
        // Validate inputs
        if (!selectedWeight) {
            alert("Please enter a weight");
            return;
        }
        
        // Create array of plant IDs
        const plantIds = Array.isArray(selected_plant_id) ? selected_plant_id : [selected_plant_id];
        
        // Send a single request with an array of plant IDs
        const requestData = {
            weight_g: parseFloat(selectedWeight),
            plant_material: selectedPlantMaterial,
            reason: selectedReason,
            plant_id: plantIds
        };
        
        await axios.post(
            `/orgs/${org_id}/maintenance/destruction`,
            requestData,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        alert('Upload complete');
        onBack && onBack(); // Return to previous screen after successful upload
    } catch (err) {
        console.error('Upload failed:', err);
        if (err.response?.status === 400) {
                alert('Upload failed - Check if all required fields are filled in correctly');
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                alert("Upload failed - You are no longer logged in or you don't have access to this resource");
            } else if (err.response?.status === 500) {
                alert("Upload failed - Something went wrong in the service, please try again later");
            } else {
                alert(`Upload failed with error: ${err.response}`);
            }
    }
};

    return(
        <>
        <div className="maintenanceHeader">
            <h3>Destruction</h3>
            <button className="uploadMaintenanceBtn" onClick={handleUpload}>Upload</button>
        </div>

        <div className="maintenaceGrid maintenanceList">
          <div className="dropdownBlock">
        <div className="purpleBtn extraGridBtn blueBtn" onClick={onBack}>
          Back
        </div>
        </div>
          
          {plantCount > 1 && (
            <div className="plotMaintenanceNotice">
              Applying destruction maintenance to all plants in plot ({plantCount} plants)
            </div>
          )}
        </div>
        <table className="maintenanceTable" style={{ marginBottom: "20px" }}>
            <tbody>
              <tr>
                <td>
                  <p>Weight:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedWeight}
                    onKeyDown={(e) => {
                      const isNumber = /[0-9]/.test(e.key);
                      const isDot = e.key === ".";
                      const hasDot = e.target.value.includes(".");
                      if ((!isNumber && !isDot) || (isDot && hasDot)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 1
                        ) {
                          return;
                        }
                        setSelectedWeight(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "11vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    g
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Plant material:</p>
                </td>
                <td>
                  <label>
                    <input
                      type="radio"
                      name="from"
                      value="Leaf"
                      checked={selectedPlantMaterial === "Leaf"}
                      onChange={(e) => setSelectedPlantMaterial(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Leaf
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="from"
                      value="Flower"
                      checked={selectedPlantMaterial === "Flower"}
                      onChange={(e) => setSelectedPlantMaterial(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Flower
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="from"
                      value="Whole plant"
                      checked={selectedPlantMaterial === "Whole plant"}
                      onChange={(e) => setSelectedPlantMaterial(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Whole plant
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Reason for destruction:</p>
                </td>
                <td>
                  <label>
                    <input
                      type="radio"
                      name="to"
                      value="Infected"
                      checked={selectedReason === "Infected"}
                      onChange={(e) => setSelectedReason(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Infected
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="to"
                      value="Dead"
                      checked={selectedReason === "Dead"}
                      onChange={(e) => setSelectedReason(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Dead
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="to"
                      value="Other"
                      checked={selectedReason === "Other"}
                      onChange={(e) => setSelectedReason(e.target.value)}
                      className="tableRadio tableRadioScouting"
                    />
                    Other
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          </>
    )
}